<template>

    <div class="navigation__wrapper">
        <a @click="prevStage" :class="{disabled: isThisBeginning()}">
          <i class="icon-anita-arrow-left"></i>
        </a>
        <ul>
          <li v-for="index in this.total" :key="index" :class="{current: amISelected(index)}">
            <a @click="jumpStage(index)"></a>
          </li>
        </ul>
        <a @click="nextStage" :class="{disabled: isThisEnd()}">
          <i class="icon-anita-arrow-right"></i>
        </a>
    </div>

</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'phase', 'total'
        ],


        methods: {
          amISelected(i) {
            let selectedClass = false;
            (this.phase === i)? selectedClass = true : "";

            return selectedClass;
          },

          isThisBeginning() {
            let beg = false;
            (this.phase === 1)? beg = true : "";

            return beg;
          },

          isThisEnd() {
            let end = false;
            (this.phase === this.total) ? end = true : "";

            return end;
          },

          nextStage() {
            this.$emit('move-forward');
          }, 

          prevStage() {
            this.$emit('move-back');
          },

          jumpStage(i) {
            this.$emit('jump-stage', i);
          }
        }
    }

</script>